export const OVERVIEW_LIST_ITEM_ID_PREFIX = 'overview-list-item-';
